export default "__VITE_ASSET__BFgAr2Hv__"